import { useController, Control, FieldValues, Path } from 'react-hook-form';
import { CircleHelp as IconHelp } from 'lucide-react';

interface ToggleButtonProps<T extends FieldValues> {
  label?: string;
  name: Path<T>;
  control: Control<T>;
  helpText?: string;
}

const ToggleButton = <T extends FieldValues>({
  label,
  name,
  control,
  helpText,
}: ToggleButtonProps<T>) => {
  const { field } = useController({ control, name });

  return (
    <div className='flex flex-row gap-3 items-center'>
      <input
        id={`${field.name}-form-toggle-button`}
        aria-labelledby={`${field.name}-form-label ${field.name}-form-help-text`}
        type='checkbox'
        className='toggle'
        checked={field.value ?? false}
        onChange={field.onChange}
      />
      <label
        id={`${field.name}-form-label`}
        htmlFor={`${field.name}-form-toggle-button`}
        className='text-xs font-semibold'
      >
        {label || ''}
      </label>
      {helpText && (
        <IconHelp
          id={`${field.name}-form-help-text`}
          aria-hidden='true'
          tabIndex={-1}
          data-tooltip-id='chenook-tooltip'
          data-tooltip-content={helpText}
          size={12}
        />
      )}
    </div>
  );
};

export default ToggleButton;
